import * as Types from '@typings/graphql-models';

type ThisPrice = Pick<Types.Price, 'price'>;

const isFreePrice = (price: ThisPrice): boolean => price.price === 0;

export default isFreePrice;